import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  recordedClassData: [],
  totalrecordedClass: 0,
  isOpenModal: false,
}

export const recordedClassSlice = createSlice({
  name: "recordedClass",
  initialState,
  reducers: {
    setrecordedClassData(state, { payload }) {
      state.recordedClassData = payload
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setrecordedClassData, isOpenModal,  ModalToggle } = recordedClassSlice.actions;

export default recordedClassSlice.reducer;

export function getrecordedClass(id) {
  return async function getrecordedClassThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getrecordedClass(id).then(
        (response) => {         
          dispatch(setLoading(false))
          dispatch(setrecordedClassData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addrecordedClass(data, id) {
  return async function addrecordedClassThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addrecordedClass(data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          successHandler('Added Successfully')
            dispatch(getrecordedClass(id));
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



